import axios from "axios";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});
axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = "Bearer " + token;
  }
  return config;
});
// axiosInstance.interceptors.response.use(
//   (response) => {
//     return response;
//   },
//   async (error) => {
//     const { status } = error;
//     console.log('status :', status)
//     if (status === 404) {
//       window.location = "/404";
//     } else if (status === 500) {
//       window.location = "/500";
//     }
//     // else if (status === 401) {
//     //   window.location = "/401";
//     // }
//     return error;
//   }
// );

export default axiosInstance;
